var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(!_vm.isLogin)?[_c('el-empty',{staticClass:"n",attrs:{"description":"未登录"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('login')}}},[_vm._v("去登录")])],1)]:_c('logined-home')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }